module.exports = __webpack_public_path__ + "img/cellres_shaojun_2021.446d8701.jpg";